import { CODING_SHOT, DEFAULT_LOCALE, isRemovableEmptySlot, mergeShotsWithTemplate } from "./lib/helpers";

import { sortShots } from "./lib/helpers";

const initialState = {
    [DEFAULT_LOCALE.value]: [],
};

const reducer = (state, action) => {
    var newShots = [];
    switch (action.type) {
        case "INIT":
            return {
                ...state,
                ...action.shots,
            };
        case "ADD_LOCALE":
            const newLocaleShots = action.localeTemplate
                .map((lt) => {
                    return {
                        ...lt,
                        localeCode: action.localeCode,
                    };
                })
                .sort(sortShots);

            return {
                ...state,
                [action.localeCode]: newLocaleShots,
            };
        case "ADD_PLACEHOLDERS":
            newShots = [...state[action.localeCode], ...action.placeholders].sort(sortShots);

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "REMOVE_PLACEHOLDER":
            newShots = state[action.localeCode]
                .filter((s) => {
                    return !(s.imageViewCode === action.imageViewCode);
                })
                .sort(sortShots);

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "REMOVE_EMPTY_PLACEHOLDERS":
            return Object.keys(state).reduce((nextState, localeCode) => {
                nextState[localeCode] = state[localeCode].filter((s) => !isRemovableEmptySlot(s, action.packageTemplate));

                return nextState;
            }, {});
        case "ADD_PHOTOS":
            //MERGE new photos, add new if coding
            const uploadsByKey = action.uploadedPhotos.map((u) => u.key);
            newShots = mergeShotsWithTemplate(action.uploadedPhotos, [...state[action.localeCode]], action.localeCode)
                .map((s) => {
                    return uploadsByKey.includes(s.key) ? { ...s, isUploading: false } : { ...s };
                })
                .filter((s) => !s.isTemporary)
                .sort(sortShots);

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "REMOVE_PHOTO":
            newShots = state[action.localeCode].filter((p) => p.key !== action.photoKey);

            if (action.placeholder) {
                newShots.push({
                    ...action.placeholder,
                    localeCode: action.localeCode,
                });
            }

            return {
                ...state,
                [action.localeCode]: newShots.sort(sortShots),
            };
        case "UPDATE_PHOTO":
            newShots = state[action.localeCode].map((photo) => {
                if (photo.key === action.uploadedPhoto.key) {
                    return {
                        ...photo,
                        editedBlobKey: action.uploadedPhoto.editedBlobKey,
                        editedImageUris: action.uploadedPhoto.editedImageUris,
                        uneditedImageUris: action.uploadedPhoto.uneditedImageUris,
                        uneditedBlobKey: action.uploadedPhoto.uneditedBlobKey,
                        isUploading: false,
                    };
                }

                return photo;
            });

            return {
                ...state,
                [action.localeCode]: newShots.sort(sortShots),
            };
        case "UPDATE_GS1_CODE":
            newShots = state[action.localeCode].map((photo) => {
                if (action.shotKey === photo.key) {
                    return {
                        ...photo,
                        gs1MetadataShortDescription: action.shortDescription,
                        hasGs1Metadata: action.shortDescription ? true : false,
                    };
                }

                return photo;
            });

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "REMOVE_LOCALE":
            const newState = Object.keys(state).reduce((obj, key) => {
                if (key !== action.localeCode) {
                    obj[key] = state[key];
                }

                return obj;
            }, {});

            return {
                ...newState,
            };
        case "CHANGE_PACKAGE_TYPE":
            return {
                ...state,
                [action.localeCode]: action.localeShots,
            };
        case "SET_UPLOADING":
            newShots = state[action.localeCode].map((shot) => {
                var isUploading = shot.isUploading;

                if (action.uploadsByShortcode) {
                    isUploading =
                        action.uploadsByShortcode.includes(shot.imageViewCode) && !shot.uneditedBlobKey ? action.isUploading : shot.isUploading;
                } else if (action.uploadsByKey) {
                    isUploading = action.uploadsByKey.includes(shot.key) ? action.isUploading : shot.isUploading;
                }

                return {
                    ...shot,
                    isUploading: isUploading,
                };
            });

            if (action.uploadsByShortcode) {
                const timestamp = Math.round(new Date().getTime() / 1000);
                action.uploadsByShortcode.forEach((c, i) => {
                    if (c === CODING_SHOT.imageViewCode) {
                        newShots.push({ key: `${timestamp}${i}`, isTemporary: true, ...CODING_SHOT, isUploading: true });
                    }
                });
            }

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "SET_PROPERTIES":
            newShots = state[action.localeCode].map((shot) => {
                const newProperty = action.shotKeys.includes(shot.key) ? { [action.property]: action.value } : {};
                const resetSelect = action.property !== "isSelected" && action.shotKeys.includes(shot.key) ? { isSelected: false } : {};

                return {
                    ...shot,
                    ...newProperty,
                    ...resetSelect,
                };
            });

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "SET_ROTATING":
            newShots = state[action.localeCode].map((shot) => {
                const isRotating = action.rotateKeys.includes(shot.key) ? action.isRotating : shot.isRotating;

                return {
                    ...shot,
                    isRotating,
                };
            });

            return {
                ...state,
                [action.localeCode]: newShots,
            };
        case "SWAP_PHOTOS":
            // Fitler out replacement images
            newShots = state[action.localeCode].filter(
                (s) =>
                    !(action.removeImageViewCodes.includes(s.imageViewCode) && s.imageViewCode !== CODING_SHOT.imageViewCode) &&
                    !action.removeKeys.includes(s.key)
            );

            return {
                ...state,
                [action.localeCode]: [...newShots, ...action.replacementShots].sort(sortShots),
            };

        case "COPY_SHOT_START": {
            return {
                ...state,
                // isCopyingToEmptyCodingPlaceholder: action.isCopyingToEmptyCodingPlaceholder,
                [action.localeCode]: state[action.localeCode].map((shot) => {
                    if (shot.key === action.targetShotKey && shot.imageViewCode === action.imageViewCode) {
                        return {
                            ...shot,
                            copyInProgress: true,
                        };
                    }

                    return shot;
                }),
            };
        }

        case "COPY_SHOT_FINISH": {
            const shots = state[action.localeCode].map((shot) => {
                if (shot.imageViewCode === action.copiedShot.imageViewCode && shot.id === action.id) {
                    return {
                        ...action.copiedShot,
                        hasGs1Metadata: action.copiedShot.isGs1MetadataEligible && action.showGs1Codes,
                    };
                }

                if (shot.key === action.sourceWipShotKey && !action.copiedShot.isGs1MetadataEligible && shot.hasGs1Metadata) {
                    return {
                        ...shot,
                        gs1MetadataShortDescription: "",
                        hasGs1Metadata: false,
                    };
                }

                return shot;
            });

            if (action.isCopyingToEmptyCodingPlaceholder) {
                shots.push(action.copiedShot);
            }

            return {
                ...state,
                [action.localeCode]: shots,
            };
        }

        default:
            return state;
    }
};

export { reducer, initialState };
